<template>
    <div>
        <div class="pane-content" style="display:flex;align-items:stretch;gap:16px;height:calc(100vh - 150px);min-height:620px;padding:0 16px;box-sizing:border-box;">
            <div class="content-params" style="width:620px;min-width:620px;flex:0 0 620px;overflow-y:auto;box-sizing:border-box;"><!-- v-if="Mech_Results" -->
                <div class="feature-panel">
                    <div class="feature-header">
                        <div class="feature-title">特征值</div>
                        <img @click="downloadData()" src="@/assets/export_white.png" class="default-image"/>
                    </div>
                    <table class="feature-table">
                        <thead>
                            <tr>
                                <th>参数</th>
                                <th>值</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in featureRows" :key="row.key">
                                <td>{{ row.label }}</td>
                                <td>
                                    <div class="table-value">
                                        <span>{{ row.value }}</span>
                                        <span v-if="row.statusDirection" :class="['range-arrow', 'range-arrow-' + row.statusDirection, 'range-arrow-level-' + row.level]"></span>
                                    </div>
                                    <div class="table-range" v-if="showRange && row.range">{{ row.range }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <div class="title"><h3>特征参数</h3></div> -->
                <div class="details">
                    <div class="details-item">
                        <div class="item-label">动作</div> <div class="item-value">{{mechState[Mech_Results.CoilA.ON_OFF_STATE?Mech_Results.CoilA.ON_OFF_STATE:0] || '-'}}</div>
                    </div>
                    <div class="details-item">
                        <div class="item-label"></div> 
                        <div class="item-value"></div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">操作时间</div> <div class="item-value">{{ dataInfo && dataInfo.Mech_On_Coil_I?formatDate(dataInfo.Mech_On_Coil_I.acqtime):''}}</div>
                    </div>
                    <div class="details-item" v-if="on==2">
                        <div class="item-label">合闸时间</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.ON_T1 != null ? Mech_Results.CoilA.ON_T1 + ' ms' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.ON_T1 != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_T1&&dataInfo.Mech_Alarm_level.CoilA.ON_T1.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_T1&&dataInfo.Mech_Alarm_level.CoilA.ON_T1.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_T1&&dataInfo.Mech_Alarm_level.CoilA.ON_T1.warn_max || '-' }}ms)</div>
                        </div>
                    </div>
                    <div class="details-item" v-if="on==2">
                        <div class="item-label">合闸同期性</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.ON_dt != null ? Mech_Results.CoilA.ON_dt + ' ms' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.ON_dt != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_dt&&dataInfo.Mech_Alarm_level.CoilA.ON_dt.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_dt&&dataInfo.Mech_Alarm_level.CoilA.ON_dt.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_dt&&dataInfo.Mech_Alarm_level.CoilA.ON_dt.warn_max || '-' }}ms)</div>
                        </div>
                    </div>
                    <div class="details-item" v-if="on==2">
                        <div class="item-label">合闸速度</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.ON_V != null ? Mech_Results.CoilA.ON_V + ' m/s' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.ON_V != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_V&&dataInfo.Mech_Alarm_level.CoilA.ON_V.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_V&&dataInfo.Mech_Alarm_level.CoilA.ON_V.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ON_V&&dataInfo.Mech_Alarm_level.CoilA.ON_V.warn_max || '-' }}m/s)</div>
                        </div>
                    </div>
                    <div class="details-item" v-if="on==1">
                        <div class="item-label">分闸时间</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.OFF_T2 != null ? Mech_Results.CoilA.OFF_T2 + ' ms' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.OFF_T2 != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_T2&&dataInfo.Mech_Alarm_level.CoilA.OFF_T2.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_T2&&dataInfo.Mech_Alarm_level.CoilA.OFF_T2.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_T2&&dataInfo.Mech_Alarm_level.CoilA.OFF_T2.warn_max || '-' }}ms)</div>
                        </div>
                    </div>
                    <div class="details-item" v-if="on==1">
                        <div class="item-label">分闸同期性</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.OFF_dt != null ? Mech_Results.CoilA.OFF_dt + ' ms' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.OFF_dt != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_dt&&dataInfo.Mech_Alarm_level.CoilA.OFF_dt.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_dt&&dataInfo.Mech_Alarm_level.CoilA.OFF_dt.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_dt&&dataInfo.Mech_Alarm_level.CoilA.OFF_dt.warn_max || '-' }}ms)</div>
                        </div>
                    </div>
                    <div class="details-item" v-if="on==1">
                        <div class="item-label">分闸速度</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.OFF_V != null ? Mech_Results.CoilA.OFF_V + ' m/s' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.OFF_V != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_V&&dataInfo.Mech_Alarm_level.CoilA.OFF_V.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_V&&dataInfo.Mech_Alarm_level.CoilA.OFF_V.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.OFF_V&&dataInfo.Mech_Alarm_level.CoilA.OFF_V.warn_max || '-' }}m/s)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">线圈最大电流</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.t6_A != null ? Mech_Results.CoilA.t6_A + ' A' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.t6_A != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.t6_A&&dataInfo.Mech_Alarm_level.CoilA.t6_A.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.t6_A&&dataInfo.Mech_Alarm_level.CoilA.t6_A.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.t6_A&&dataInfo.Mech_Alarm_level.CoilA.t6_A.warn_max || '-' }}A)</div>
                        </div>
                    </div>
                    <!--<div class="details-item">
                        <div class="item-label">掣子脱扣时间</div> <div class="item-value">{{Mech_Results.CoilA.t4}} ms</div>
                    </div>-->
                    <div class="details-item">
                        <div class="item-label">行程</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.discount != null ? Mech_Results.CoilA.discount + ' mm' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.discount != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.discount&&dataInfo.Mech_Alarm_level.CoilA.discount.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.discount&&dataInfo.Mech_Alarm_level.CoilA.discount.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.discount&&dataInfo.Mech_Alarm_level.CoilA.discount.warn_max || '-' }}mm)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">线圈通电时间</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.t7 != null ? Mech_Results.CoilA.t7 + ' ms' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.t7 != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.t7&&dataInfo.Mech_Alarm_level.CoilA.t7.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.t7&&dataInfo.Mech_Alarm_level.CoilA.t7.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.t7&&dataInfo.Mech_Alarm_level.CoilA.t7.warn_max || '-' }}ms)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">过冲</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.overshoot != null ? Mech_Results.CoilA.overshoot + ' mm' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.overshoot != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.overshoot&&dataInfo.Mech_Alarm_level.CoilA.overshoot.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.overshoot&&dataInfo.Mech_Alarm_level.CoilA.overshoot.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.overshoot&&dataInfo.Mech_Alarm_level.CoilA.overshoot.warn_max || '-' }}mm)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">开距</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.open_dis != null ? Mech_Results.CoilA.open_dis + ' mm' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.open_dis != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.open_dis&&dataInfo.Mech_Alarm_level.CoilA.open_dis.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.open_dis&&dataInfo.Mech_Alarm_level.CoilA.open_dis.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.open_dis&&dataInfo.Mech_Alarm_level.CoilA.open_dis.warn_max || '-' }}mm)</div>
                        </div>
                    </div>
                    <div class="details-item">
                        <div class="item-label">超行程</div> 
                        <div class="item-value-wrapper">
                            <div class="value-row">
                                <span class="item-value">{{Mech_Results.CoilA.ultra_dis != null ? Mech_Results.CoilA.ultra_dis + ' mm' : '-'}}</span>
                                <span v-if="Mech_Results.CoilA.ultra_dis != null" :class="['status-dot', getAlarmStatus(dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ultra_dis&&dataInfo.Mech_Alarm_level.CoilA.ultra_dis.level).class]"></span>
                            </div>
                            <div class="range-row" v-if="showRange">({{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ultra_dis&&dataInfo.Mech_Alarm_level.CoilA.ultra_dis.warn_min || '-' }}~{{ dataInfo.Mech_Alarm_level&&dataInfo.Mech_Alarm_level.CoilA&&dataInfo.Mech_Alarm_level.CoilA.ultra_dis&&dataInfo.Mech_Alarm_level.CoilA.ultra_dis.warn_max || '-' }}mm)</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-chart" style="flex:1 1 auto;min-width:0;height:100%;">
                <div id="current" ref="current" class="current" style="width:100%;height:33.5%;min-height:180px;"></div>
                <div id="switch" ref="switch" class="switch" style="width:100%;height:33.5%;min-height:180px;"></div>
                <div id="dis" ref="dis" class="dis" style="width:100%;height:33.5%;min-height:180px;"></div>
            </div>

        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import * as file from '@/data/file.js'
export default {
    name: "",
    props:{
        dataInfo:{
            type:Object,
            default:()=>{}
        },
        showRange:{
            type:Boolean,
            default:false
        }
    },
    watch: {
        dataInfo(val) {
          if(!val)return
          this.renderWithLoading();
        }
    },
    computed: {
        featureRows() {
            const rows = [
                {
                    label: '动作',
                    key: 'state',
                    value: this.mechState[this.Mech_Results.CoilA.ON_OFF_STATE ? this.Mech_Results.CoilA.ON_OFF_STATE : 0] || '-'
                },
                {
                    label: '操作时间',
                    key: 'time',
                    value: this.dataInfo && this.dataInfo.Mech_On_Coil_I ? this.formatDate(this.dataInfo.Mech_On_Coil_I.acqtime) : '-'
                }
            ]
            if (this.on == 1) {
                rows.push(
                    this.buildFeatureRow('分闸时间', 'OFF_T2', ' ms'),
                    this.buildFeatureRow('分闸速度', 'OFF_V', ' m/s'),
                    this.buildFeatureRow('分闸同期性', 'OFF_dt', ' ms')
                )
            }
            if (this.on == 2) {
                rows.push(
                    this.buildFeatureRow('合闸时间', 'ON_T1', ' ms'),
                    this.buildFeatureRow('合闸速度', 'ON_V', ' m/s'),
                    this.buildFeatureRow('合闸同期性', 'ON_dt', ' ms')
                )
            }
            return rows.concat([
                this.buildFeatureRow('线圈最大电流', 't6_A', ' A'),
                this.buildFeatureRow('行程', 'discount', ' mm'),
                this.buildFeatureRow('线圈通电时间', 't7', ' ms'),
                this.buildFeatureRow('过冲', 'overshoot', ' mm'),
                this.buildFeatureRow('开距', 'open_dis', ' mm'),
                this.buildFeatureRow('超行程', 'ultra_dis', ' mm')
            ])
        }
    },
    data() {
        return {
            dlqData: {},
            switchChart: null,
            disChart: null,
            currentChart: null,
            on:1,
            option: {
                title: {
                    left:'center',
                    text: '',
                    textStyle: {
                        color: '#b5b5b5ff',
                        fontSize:13
                    }
                },
                animation: false,
                animationDuration: 0,
                tooltip: {
                    trigger: 'axis',
                    // formatter: '{b}(s) <br/>{a} : {c} (A)'
                },
                toolbox: {
                        show: 1, 
                        x: 'right', 
                        y: 'top', 
                        itemSize: 14,
                        itemGap: 8,
                        feature: {
                            dataZoom: [
                                { 
                                    type: 'inside',
                                    show: true, 
                                    realtime: true,                                                               
                                    start: 0,  
                                    end: 100,
                                    iconStyle: {
                                        borderColor: '#FFFFFF',
                                    }
                                },
                                {
                                    type: 'inside',
                                    realtime: true,
                                    start: 0,
                                    end: 100,
                                    iconStyle: {
                                        borderColor: '#FFFFFF',
                                    }
                                }
                            ],
                            restore: {
                                show: true, // 显示还原按钮
                                title: '还原',
                                iconStyle: {
                                    borderColor: "#FFFFFF"
                                }
                            },
                            saveAsImage: {
                                show: true, 
                                title: '保存截图',
                                type: 'jpg',
                                backgroundColor: '#000000',
                                iconStyle: {
                                    borderColor: "#FFFFFF",
                                },
                                name: '线圈电流_主回路电流_行程'
                            }
                        },
                        iconStyle: {
                        borderColor: '#ffffff'
                        }
                    },
                dataZoom: [
                    {
                        type: 'inside',
                        xAxisIndex: 0,
                        animation: false,
                    }
                ],
                legend: {
                    padding:[26,0,0,0],
                    orient: 'vertical',
                    right: 20, // 靠右，距离右侧边缘10px
                    top: 'center', // 垂直居中（可改为'top'或具体像素值调整上下位置）
                    itemWidth: 14,
                    itemHeight: 8,
                    itemGap: 8,
                    textStyle: {
                        color: '#b5b5b5ff',
                        fontSize: 11
                    }
                },
                grid: {
                    top: '12%',
                    right: '8%',
                    left: '8%',
                    bottom: '20%'
                },
                xAxis: {
                    type: 'category',
                    name: '时间(ms)',
                    nameLocation: "center",
                    nameTextStyle: {
                        color:'#e1d8d8ff',
                        fontSize: 11
                    },
                    nameGap: 30,
                    data: [],
                    axisLabel: {
                        textStyle: {
                        color: '#8f8888ff',
                        fontSize: 10
                        },
                        interval: 99,
                    },
                    axisTick: {
                        show: true
                    },
                    axisLine: {
                            show: true,
                            onZero: false, 
                            lineStyle: {
                                color: '#a3a3a3ff', 
                                width: 2
                            }
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    nameLocation: "center",
                    nameTextStyle: {
                        color:'#e1d8d8ff',
                        fontSize: 11
                    },
                    nameGap: 50,
                    axisLabel: {
                        textStyle: {
                        color: '#8f8888ff',
                        fontSize: 10
                        }
                    },
                    axisTick: {
                        show: true
                    },
                    axisLine: {
                        show: true,
                        onZero: false, 
                        lineStyle: {
                            color: '#a3a3a3ff', 
                            width: 2
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                        color: 'rgba(200, 200, 200, 0.2)', // 网格线浅灰色，不干扰数据
                        type: 'dashed'
                        }
                    },
                },
                series: [
                    {
                        data: [],
                        type: 'line',
                        smooth: true,
                        name: '',
                        showSymbol: false,
                        markPoint: {
                            // 用于显示选中的数据点
                            symbol: 'pin',
                            symbolSize: 30,
                            label: {
                                show: true,
                                formatter: function(params) {
                                    return params.value;
                                },
                                color: '#fff',
                                fontSize: 10
                            },
                            itemStyle: {
                                color: '#ff4d4f'
                            },
                            data: []
                        }
                    }
                ]
            },
            seriesItem:{
                data: [],
                type: 'line',
                smooth: true
            },
            mechState: ['-', '分闸', '合闸'],
            Mech_Results: {
              CoilA:{}
            },
            chartInstance:{}
        };

    },
    mounted() {
        this.$nextTick(() => {
            if (JSON.stringify(this.dataInfo) !== '{}') {
                this.renderWithLoading();
            }

        })
    },
    beforeDestroy() {
        this.setRenderLoading(false)
        if (this.switchChart) {
          this.switchChart.dispose();
          this.switchChart = null;
        }
        if (this.disChart) {
          this.disChart.dispose();
          this.disChart = null;
        }
        if (this.currentChart) {
          this.currentChart.dispose();
          this.currentChart = null;
        }
    },
    methods: {
        setRenderLoading(val) {
            this.$emit('loading-change', val)
        },
        renderWithLoading() {
            this.setRenderLoading(true)
            this.$nextTick(async () => {
                try {
                    const visible = await this.waitForChartVisible(['switch', 'dis', 'current'])
                    if (!visible) return
                    this.init()
                } finally {
                    this.$nextTick(() => {
                        this.setRenderLoading(false)
                    })
                }
            })
        },
        waitForChartVisible(refNames, retryCount = 30) {
            return new Promise(resolve => {
                const check = count => {
                    const visible = refNames.every(refName => {
                        const el = this.$refs[refName]
                        return el && el.clientWidth > 0 && el.clientHeight > 0
                    })
                    if (visible || count <= 0) {
                        resolve(visible)
                        return
                    }
                    requestAnimationFrame(() => check(count - 1))
                }
                check(retryCount)
            })
        },
        buildFeatureRow(label, key, unit) {
            const coil = this.Mech_Results && this.Mech_Results.CoilA
            const alarm = this.dataInfo && this.dataInfo.Mech_Alarm_level && this.dataInfo.Mech_Alarm_level.CoilA && this.dataInfo.Mech_Alarm_level.CoilA[key]
            const hasValue = coil && coil[key] !== null && coil[key] !== undefined && coil[key] !== ''
            return {
                label,
                key,
                hasValue,
                value: hasValue ? coil[key] + unit : '-',
                level: alarm && alarm.level,
                statusDirection: this.getRangeDirection(hasValue ? coil[key] : null, alarm),
                range: this.formatFeatureRange(alarm, unit)
            }
        },
        getRangeDirection(value, alarm) {
            if (value === null || value === undefined || value === '' || !alarm) {
                return ''
            }
            const num = Number(value)
            if (Number.isNaN(num)) {
                return ''
            }
            const min = alarm.warn_min !== null && alarm.warn_min !== undefined && alarm.warn_min !== '' ? Number(alarm.warn_min) : null
            const max = alarm.warn_max !== null && alarm.warn_max !== undefined && alarm.warn_max !== '' ? Number(alarm.warn_max) : null
            if (max !== null && !Number.isNaN(max) && num > max) {
                return 'up'
            }
            if (min !== null && !Number.isNaN(min) && num < min) {
                return 'down'
            }
            return ''
        },
        formatFeatureRange(alarm, unit) {
            if (!alarm) {
                return ''
            }
            const min = alarm.warn_min !== null && alarm.warn_min !== undefined ? alarm.warn_min : '-'
            const max = alarm.warn_max !== null && alarm.warn_max !== undefined ? alarm.warn_max : '-'
            return `(${min}~${max}${unit.trim()})`
        },
        addListenning(myChart, _option) {
            let selectedPoint = null;
            for (let i = 0; i<_option.series.length ; i++) {
            _option.series[i].markPoint = {
                symbol: 'pin',
                symbolSize: [16, 24],
                symbolRotate: 35, 
                label: {
                    show: true, 
                    useHTML: true, 
                    formatter: function(params) {
                        return `\n\n\n\n\n\n${params.data.seriesName}时间(ms)：${params.data.xAxis / 10}\n${params.data.seriesName}${_option.yAxis.name}：${params.data.yAxis}`;
                    },
                    color: '#fff',
                    fontSize: 10
                },
                itemStyle: {
                    color: '#4da3ffff'
                },
                data: []
            }
            }
            myChart.setOption(_option, true);
            myChart.off('click'); 
            myChart.on('click', function(params) {
                if (params.componentType === 'series' && params.seriesType === 'line') {
                    // 记录选中的点
                    selectedPoint = {
                        name: params.name,
                        value: params.value,
                        dataIndex: params.dataIndex,
                        seriesName: params.seriesName
                    };
                    // 更新标记点，显示选中的数据
                    _option.series[params.seriesIndex].markPoint.data = [{
                        name: '选中值',
                        value: selectedPoint.value,
                        xAxis: selectedPoint.dataIndex,
                        yAxis: selectedPoint.value,
                        seriesName: selectedPoint.seriesName
                    }];
                    // 重新设置配置，让标记点显示
                    myChart.setOption(_option, true);
                }
            });
            myChart.on('click', (params) => {
                // 判断是否点击了图钉
                if (params.componentType === 'markPoint') {
                    //点击图钉后移除它
                    _option.series[params.seriesIndex].markPoint.data = [];
                    myChart.setOption(_option, true);
                }
            });
        },
        modifyRangeY(waveA, waveB, waveC) {
          // 正确解构获取每个波形的最小值和最大值
          const { min: min1, max: max1 } = this.findMinMax(waveA) || { min: 0, max: 0 };
          const { min: min2, max: max2 } = this.findMinMax(waveB) || { min: 0, max: 0 };
          const { min: min3, max: max3 } = this.findMinMax(waveC) || { min: 0, max: 0 };
          // 修复Math.min和Math.max的使用方式，使用扩展运算符而非数组作为参数
          let min = Math.min(min1, min2, min3);
          let max = Math.max(max1, max2, max3);

          // 计算范围和间隔，增加零值检查避免异常
          let rangeY = max - min;
          min = Number((rangeY < 0.05 ? min - 0.05 : min - rangeY * 0.2).toFixed(3))
          max = Number((rangeY < 0.05 ? max + 0.05 : max + rangeY * 0.2).toFixed(3))
          rangeY = max - min;
          const intervalY = rangeY > 0 ? Number((rangeY / 5).toFixed(3)) : 1; // 避免除以零
          return {min, max, intervalY}
        },
        findMinMax(arr) {
            if (!Array.isArray(arr) || arr.length === 0) {
            return { min: null, max: null };
            }
            let item = Number(arr[0])
            let min = item;
            let max = item;
            for (let i = 1; i < arr.length; i++) {
            item = Number(arr[i])
            if (item < min) {
                min = item;
            }
            if (item > max) {
                max = item;
            }
            }
            return { min, max };
        },
        init() {
            this.on = this.dataInfo.Mech_Results?this.dataInfo.Mech_Results.CoilA.ON_OFF_STATE:0;
            this.Mech_Results = this.dataInfo.Mech_Results
            this.initSwitchChart();
            this.initDisChart();
            this.initCurrentChart();
            this.switchChart.group = 'm10-group'
            this.disChart.group = 'm10-group'
            this.currentChart.group = 'm10-group'
            echarts.connect('m10-group');
        },
        formatDate(dateString) {
          return dateString.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})*/, '$1-$2-$3 $4:$5:$6');
        },
        initSwitchChart() {
            if (this.switchChart == null) {
                this.switchChart = echarts.init(this.$refs.switch);
            }
            let _option = JSON.parse(JSON.stringify(this.option))
            _option.color = ['#EDAE14','#57850C','#EB222D']
            _option.title.text = '主回路电流';
            _option.yAxis.name = '电流/(A)'
            // _option.grid.top = '20%'
            _option.tooltip.formatter = (params)=>{
                let res= ''
                if(Array.isArray(params)&&params.length>0){
                res +=  params[0].name+'(ms)<br/>'
                for(let i=0;i<params.length;i++){
                    const item = params[i]
                    const mark = item.marker
                    let seriesName = item.seriesName; // 系列名称
                    let value = item.value; // 数据值
                    let unit = 'A'; // 这里设置你需要的单位
                    res += `<div
                    ">${mark}${seriesName}: ${value}${unit}<div/>`;
                }
                }
                return res;
            }
            let obj = this.dataInfo.Mech_CT_A_V;
            _option.xAxis.data = this.setxAxisData(obj.wave.length, obj.samplingperiod);
            // 根据量程动态计算interval，确保显示约15个整数刻度
            const dataLength = obj.wave.length;
            const samplingPeriod = obj.samplingperiod;
            // 计算合适的间隔，确保显示约15个刻度
            const desiredTicks = 15;
            const interval = Math.round(dataLength / desiredTicks);
            _option.xAxis.axisLabel.interval = function(index, value) {
                // 强制显示第一个（index=0）和最后一个（index=totalTicks-1）刻度
                if (index === 0 || index === dataLength - 1) {
                return true; // 显示
                }
                // 中间刻度：按计算的间隔显示（每隔interval个显示一个）
                return index % interval === 0;
            };   
            _option.xAxis.axisLabel.formatter = (value) => Math.round(value); 
            _option.series[1] = JSON.parse(JSON.stringify(this.seriesItem));
            _option.series[2] = JSON.parse(JSON.stringify(this.seriesItem));
            _option.series[0].data = this.dataInfo.Mech_CT_A_V.wave;
            _option.series[0].name = 'A';
            _option.series[1].name = 'B';
            _option.series[2].name = 'C';
            _option.series[1].data = this.dataInfo.Mech_CT_B_V.wave;
            _option.series[2].data = this.dataInfo.Mech_CT_C_V.wave;
            _option.series[0].showSymbol = false;
            _option.series[1].showSymbol = false;
            _option.series[2].showSymbol = false;
            const {min, max, intervalY} = this.modifyRangeY(_option.series[0].data,_option.series[1].data, _option.series[2].data)
            _option.yAxis.min = min
            _option.yAxis.max = max
            _option.yAxis.interval = intervalY
            this.switchChart.setOption(_option, true);
            this.addListenning(this.switchChart, _option)
            this.chartInstance['switchChart'] = this.switchChart
        },
        initDisChart() {
            if (this.disChart == null) {
                this.disChart = echarts.init(this.$refs.dis);
            }
            let _option = JSON.parse(JSON.stringify(this.option))
            _option.xAxis.data = this.setxAxisData(this.dataInfo.Mech_DIS_I.wave.length, this.dataInfo.Mech_DIS_I.samplingperiod);
            let obj =  this.dataInfo.Mech_DIS_I;
            // 根据量程动态计算interval，确保显示约15个整数刻度
            const dataLength = obj.wave.length;
            const samplingPeriod = obj.samplingperiod;
            // 计算合适的间隔，确保显示约15个刻度
            const desiredTicks = 15;
            const interval = Math.round(dataLength / desiredTicks);
            _option.xAxis.axisLabel.interval = function(index, value) {
                // 强制显示第一个（index=0）和最后一个（index=totalTicks-1）刻度
                if (index === 0 || index === dataLength - 1) {
                return true; // 显示
                }
                // 中间刻度：按计算的间隔显示（每隔interval个显示一个）
                return index % interval === 0;
            };    
            _option.xAxis.axisLabel.formatter = (value) => Math.round(value);
            _option.yAxis.name = '行程/(mm)';
            _option.title.text= '行程';
            _option.tooltip.formatter = (params)=>{
                let res= ''
                if(Array.isArray(params)&&params.length>0){
                res +=  params[0].name+'(ms)<br/>'
                for(let i=0;i<params.length;i++){
                    const item = params[i]
                    const mark = item.marker
                    let value = item.value; // 数据值
                    let unit = 'mm'; // 这里设置你需要的单位
                    res += `<div
                    ">${mark} ${value}${unit}<div/>`;
                }
                }
                return res;
            }
            _option.series[0].data = this.dataInfo.Mech_DIS_I.wave;
            let {min, max} = this.findMinMax(_option.series[0].data)
            let rangeY = max - min;
            min = Number((rangeY < 0.05 ? min - 0.05 : min - rangeY * 0.2).toFixed(3))
            max = Number((rangeY < 0.05 ? max + 0.05 : max + rangeY * 0.2).toFixed(3))
            rangeY = max - min;
            const intervalY = rangeY > 0 ? Number((rangeY / 5).toFixed(3)) : 1; // 避免除以零
            _option.yAxis.min = min
            _option.yAxis.max = max
            _option.yAxis.interval = intervalY
            this.disChart.setOption(_option, true);
            this.addListenning(this.disChart, _option)
            this.chartInstance['disChart'] = this.disChart
        },
        initCurrentChart() {
            if (this.currentChart == null) {
                this.currentChart = echarts.init(this.$refs.current);
            }
            let _option = JSON.parse(JSON.stringify(this.option))
            _option.xAxis.data = this.setxAxisData(this.dataInfo.Mech_Off_Coil_I.wave.length, this.dataInfo.Mech_Off_Coil_I.samplingperiod);
            let obj = this.dataInfo.Mech_Off_Coil_I
            // 根据量程动态计算interval，确保显示约15个整数刻度
            const dataLength = obj.wave.length;
            const samplingPeriod = obj.samplingperiod;
            // 计算合适的间隔，确保显示约15个刻度
            const desiredTicks = 15;
            const interval = Math.round(dataLength / desiredTicks);
            _option.xAxis.axisLabel.interval = function(index, value) {
                // 强制显示第一个（index=0）和最后一个（index=totalTicks-1）刻度
                if (index === 0 || index === dataLength - 1) {
                return true; // 显示
                }
                // 中间刻度：按计算的间隔显示（每隔interval个显示一个）
                return index % interval === 0;
            };      
            _option.xAxis.axisLabel.formatter = (value) => Math.round(value);
            _option.title.text = '线圈电流'
            _option.yAxis.name = '电流/(A)'
            _option.tooltip.formatter = (params)=>{
                let res= ''
                if(Array.isArray(params)&&params.length>0){
                res +=  params[0].name+'(ms)<br/>'
                for(let i=0;i<params.length;i++){
                    const item = params[i]
                    const mark = item.marker
                    let value = item.value; // 数据值
                    let unit = 'A'; // 这里设置你需要的单位
                    res += `<div
                    ">${mark} ${value}${unit}<div/>`;
                }
                }
                return res;
            }
            _option.xAxis.axisLabel.show = true;
            // _option.series[1] = JSON.parse(JSON.stringify(this.seriesItem));
            // const {min, max, intervalY} = this.modifyRangeY(this.dataInfo.Mech_On_Coil_I.wave, this.dataInfo.Mech_On_Coil_I.wave, this.dataInfo.Mech_On_Coil_I.wave)
            _option.series[0].data = this.dataInfo.Mech_Results.CoilA.ON_OFF_STATE == 2?this.dataInfo.Mech_On_Coil_I.wave:this.dataInfo.Mech_Off_Coil_I.wave
            // _option.series[1].data = this.dataInfo.Mech_On_Coil_I.wave;
            let {min, max} = this.findMinMax(_option.series[0].data)
            let rangeY = max - min;
            min = Number((rangeY < 0.05 ? min - 0.05 : min - rangeY * 0.2).toFixed(3))
            max = Number((rangeY < 0.05 ? max + 0.05 : max + rangeY * 0.2).toFixed(3))
            rangeY = max - min;
            const intervalY = rangeY > 0 ? Number((rangeY / 5).toFixed(3)) : 1; // 避免除以零
            _option.yAxis.min = min
            _option.yAxis.max = max
            _option.yAxis.interval = intervalY
            this.currentChart.setOption(_option, true);
            this.addListenning(this.currentChart, _option)
            this.chartInstance['currentChart'] = this.currentChart
        },
        setxAxisData(len, period) {
            let arr = [];
            for (let i = 0; i < len; i++){
                arr.push(i*period/1000)
            }
            return arr;
        },
        getAlarmStatus(level) {
            if (level === undefined || level === null || level === '') return { label: '正常', class: 'status-normal', icon: '✓' };
            switch(level) {
              case 0: return { label: '正常', class: 'status-normal', icon: '✓' };
              case 1: return { label: '预警', class: 'status-warning', icon: '!' };
              case 2: return { label: '报警', class: 'status-alarm', icon: '✕' };
              default: return { label: '正常', class: 'status-normal', icon: '✓' };
            }
        },
        downloadData() {
        this.$confirm('是否确认导出当前数据?', '提示', {
            type: 'warning'
        }).then(() => {
            const data_info = this.dataInfo
            const dataURL = this.margeImage()
            let params = {}
            params.sensor_data_id = data_info._id
            params.sensor_type = data_info.sensor_type
            const formData = new FormData()
            const blob = this.dataURLtoBlob(dataURL);
            formData.append("sensor_file", blob, "sensor.jpg");
            file.exportSingleDetail(params, formData).then((res) => {
            })
        }).catch(() => {
            this.$message({type:'info',message:'已取消导出'});
        })
      },
      dataURLtoBlob(dataURL) {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
      },
      margeImage() {
        // 获取所有图表 canvas
        const canvas1 = this.chartInstance['currentChart'].getDom().querySelector('canvas');
        const canvas2 = this.chartInstance['switchChart'].getDom().querySelector('canvas');
        const canvas3 = this.chartInstance['disChart'].getDom().querySelector('canvas');

        // 创建合并 canvas
        const combinedCanvas = document.createElement('canvas');
        const ctx = combinedCanvas.getContext('2d');

          // 计算总高度和最大宽度
        const maxWidth = Math.max(
          canvas1.width, 
          canvas2.width, 
          canvas3.width
        );
        const totalHeight = canvas1.height + canvas2.height + canvas3.height;
        
        combinedCanvas.width = maxWidth;
        combinedCanvas.height = totalHeight;
        
        // 垂直排列四个图表
        let currentY = 0;
        
        // 填充背景色（可选）
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, maxWidth, totalHeight);

          // 绘制第一个图表
        ctx.drawImage(canvas1, (maxWidth - canvas1.width) / 2, currentY);
        currentY += canvas1.height;
        
        // 绘制第二个图表
        ctx.drawImage(canvas2, (maxWidth - canvas2.width) / 2, currentY);
        currentY += canvas2.height;
        
        // 绘制第三个图表
        ctx.drawImage(canvas3, (maxWidth - canvas3.width) / 2, currentY);
        currentY += canvas3.height;
        
        // 下载合并后的图片
        const dataURL = combinedCanvas.toDataURL('image/png');
        return dataURL 
      }
    },
};
</script>

<style lang='less' scoped>

    .switch, .dis ,.current{
        height:33.5%;width:100%;
    }
    .content-params{
        padding:0 20px;box-sizing: border-box;
        .title{
            width:100%;text-align: center;
        }
        .details{
            width:100%;text-align:center;
            display: flex;
            flex-wrap: wrap;
            .details-item{
                width:33%;
                display: flex; line-height: 30px;
                // justify-content: space-evenly;
                border:solid 1px #666;
                margin-top:15px;
                .el-row{
                    width:100%;
                }
                .item-label{
                    width:50%;
                    border-right:solid 1px #666;
                }
                .item-label-m{
                    width:50%;
                    border-right:solid 1px #666;
                }
                .item-value{
                    width:80%;height:30px;
                    background:#666
                }
            }

        }

    }
    .el-icon-share:hover {
      cursor: pointer;
      color:rgb(72, 173, 207);
    }
.default-image {
    width: 20px;
    height: 20px; 
    flex-shrink: 0;
}
.default-image:hover {
     content: url("../../assets/export_blue.png");
     cursor: pointer;
}
.info {
    text-align: center;
    color: #666;
    margin-top: 20px;
}
.item-value-wrapper {
    width: 50%;
    min-height: 30px;
    background: #666;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}
.value-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 30px;
    line-height: 30px;
}
.value-row .item-value {
    flex-shrink: 0;
    white-space: nowrap;
}
.value-row .status-dot {
    flex-shrink: 0;
}
.range-arrow {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    font-size: 20px;
    font-weight: 900;
    line-height: 14px;
}
.range-arrow-up {
    color: #f5222d;
}
.range-arrow-up::before {
    content: "↑";
}
.range-arrow-down {
    color: #f5222d;
}
.range-arrow-level-1 {
    color: #faad14;
}
.range-arrow-level-2 {
    color: #f5222d;
}
.range-arrow-down::before {
    content: "↓";
}
.range-row {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #ffffff;
    font-size: 13px;
}
.status-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    box-shadow: 0 0 6px currentColor;
}
.status-normal {
    background-color: #52c41a;
    color: #52c41a;
}
.status-warning {
    background-color: #faad14;
    color: #faad14;
}
.status-alarm {
    background-color: #f5222d;
    color: #f5222d;
}
.pane-content {
    display: flex;
    gap: 16px;
    height: calc(100vh - 150px);
    min-height: 620px;
    padding: 0 16px;
    box-sizing: border-box;
}
.content-params {
    width: 620px;
    min-width: 620px;
    flex-basis: 620px;
    flex-shrink: 0;
    overflow-y: auto;
}
.content-chart {
    flex: 1;
    min-width: 0;
    height: 100%;
}
.content-params > .details {
    display: none;
}
.feature-panel {
    padding-top: 8px;
}
.feature-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
}
.feature-title {
    height: 32px;
    line-height: 32px;
    text-align: center;
    font-weight: 700;
    color: #f4d759;
}
.feature-header .default-image {
    position: absolute;
    right: 0;
}
.feature-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    color: #fff;
    font-size: 13px;
}
.feature-table th,
.feature-table td {
    border: 1px solid #666;
    padding: 6px 5px;
    text-align: center;
    vertical-align: middle;
}
.feature-table th {
    background: #3a3d40;
    color: #f4d759;
    font-weight: 600;
}
.feature-table td:first-child {
    width: 44%;
    background: #343638;
    color: #d7d7d7;
}
.table-value {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}
.table-range {
    margin-top: 3px;
    color: #cfd3d8;
    font-size: 12px;
    line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/site/dlq.vue